export default function getInfoBarMessageIdsInReadingPane(viewState) {
    return viewState.infoBarIds;
}
//# sourceMappingURL=getInfoBarMessageIdsInReadingPane.js.map